@use 'shared/styles/generated/tokens' as *;
@use 'shared/styles/mixins' as *;

.root {
  min-width: 0;
  border-radius: $radius-card;
}

// Крестик — обычный сосед текста в ряду, а не абсолют поверх него (правка основателя:
// «крестик должен быть выровнен справа сверху, а не по середине, на него текст залезает»).
//
// Абсолют не работал по двум причинам сразу: коробка кнопки 44×44 держит глиф в СВОЁМ центре,
// то есть в 22px от верха карточки — в карточке высотой в одну-две строки это ровно середина;
// и текст под абсолютом не сжимался, а затекал под крестик. Ряд чинит оба: `flex-start`
// прижимает кнопку к верхней кромке, а текстовая колонка честно занимает место до неё
// и переносится раньше. Растянуть строку кнопка не может — её коробка теперь размером
// с глиф (`IconButton size='XS'`), а 44px зоны нажатия добираются псевдоэлементом наружу.
.body {
  display: flex;
  align-items: flex-start;
  gap: $space-small-s;
}

.text {
  flex: 1;
  min-width: 0;
}

.close {
  flex: none;
  // Коробка кнопки на 4px шире глифа с каждой стороны — уводим её на эти же 4px вверх
  // и вправо, чтобы сам крестик встал вровень с верхом оверлайна и с правым краем контента.
  margin: calc(-1 * #{$space-small-xs}) calc(-1 * #{$space-small-xs}) 0 0;
}

// Тема BLUR — стеклянная подложка поверх фона (backdrop-filter недоступен базовому Card).
.theme_BLUR {
  background: $color-surface-blur;
  box-shadow: $shadow-card;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

.padding_S {
  padding: $space-medium-xs;
}
.padding_M {
  padding: $space-medium-s;
}
.padding_L {
  padding: $space-medium-l;
}
